var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// libs
import React, { memo } from 'react';
// HOC
import withIconDefaults from './withIconDefaults';
function IconChevronDown(_a) {
    var { fillColor, opacity } = _a, props = __rest(_a, ["fillColor", "opacity"]);
    return (React.createElement("svg", Object.assign({ width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { id: "ChevronDown" },
            React.createElement("path", { id: "ChevronDown", fillRule: "evenodd", clipRule: "evenodd", d: "M1.66363 4.69212L1.63514 4.6509L1.63514 4.65089C1.46925 4.41092 1.29231 4.15496 1.18085 3.92888C1.06373 3.6913 0.88245 3.21827 1.14776 2.71555C1.41307 2.21283 1.90588 2.09555 2.16811 2.05818C2.41766 2.02261 2.72881 2.02425 3.02054 2.02578L3.07066 2.02604L8.95553 2.05452L9.00539 2.05475C9.2941 2.05602 9.60297 2.05738 9.85068 2.09518C10.1122 2.13509 10.5997 2.25679 10.8606 2.75734C11.1214 3.25789 10.942 3.72715 10.8249 3.96441C10.714 4.18911 10.5382 4.44306 10.3739 4.68045L10.3739 4.68047L10.3455 4.72147L7.41096 8.9647L7.38654 9.00005C7.25931 9.18425 7.11322 9.39576 6.96576 9.55359C6.79549 9.73585 6.48341 10.0014 6.01214 10.0013C5.54088 10.0011 5.22896 9.73537 5.0588 9.553C4.91143 9.39507 4.76548 9.18348 4.63837 8.9992L4.63836 8.9992L4.61396 8.96383L1.66363 4.69212Z", fill: fillColor, fillOpacity: opacity }))));
}
export default memo(withIconDefaults(IconChevronDown));
